import { Facility, UnitGroup } from "@/types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function flattenObject(obj: any, prefix = ""): Record<string, string | number | null> {
  return Object.keys(obj).reduce((acc, key) => {
    const value = obj[key];
    const newKey = prefix ? `${prefix}.${key}` : key;

    if (Array.isArray(value)) {
      // Handle arrays
      value.forEach((item, index) => {
        if (item && typeof item === "object" && "key" in item && "value" in item) {
          // Map key-value pairs
          acc[`${newKey}.${item.key}`] = item.value;
        } else if (item && typeof item === "object") {
          // Flatten object within the array
          Object.assign(acc, flattenObject(item, `${newKey}.${index}`));
        } else {
          // Primitive values
          acc[`${newKey}.${index}`] = item;
        }
      });
    } else if (value && typeof value === "object") {
      // Flatten nested objects
      Object.assign(acc, flattenObject(value, newKey));
    } else {
      // Primitive value
      acc[newKey] = value;
    }

    return acc;
  }, {} as Record<string, string | number | null>);
}

type Promo = {
  id: number;
}

export function translateWithMultipleSources(
  template: string,
  sources: Record<string, UnitGroup | Facility | Promo>,
  selectedUnitId: number,
  selectedPromoId: number
): string {
  // Need to reference specific instance information
  const selectedUnit = sources.unitGroup.available_units.find((unit) => unit.id === selectedUnitId);
  const selectedPromo = sources.unitGroup.rates.promo_rates.find((promo) => promo.id === selectedPromoId);

  if (selectedUnit) {
    sources.unitGroup = {
      ...sources.unitGroup, representative_unit: selectedUnit, rates: {
        ...sources.unitGroup.rates,
        promo_rates: selectedPromo ? [selectedPromo] : sources.unitGroup.rates.promo_rates
      }
    };
  }
  // Flatten all data sources
  const flatData = Object.keys(sources).reduce((acc, key) => {
    const source = sources[key];
    Object.assign(acc, flattenObject(source, key));
    return acc;
  }, {} as Record<string, string | number | null>);

  // Replace placeholders with actual data
  return template.replace(/{{(.*?)}}/g, (_, key) => {
    const value = flatData[key];
    return value !== undefined ? String(value) : `{{${key}}}`;
  });
}
